export default "__VITE_ASSET__BWHhYfjT__"